import axios from 'axios';

const apiServices = axios.create({ baseURL: import.meta.env.VITE_BASE_URL_API || 'http://localhost:3010/' });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

apiServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 && !window.location.href.includes('/login')) {
      // window.location.pathname = '/maintenance/500';
    }
    return Promise.reject(error);
  }
);

export default apiServices;


// use this if request need connectors id if not use apiServices
export const connectorClient = (connectionId) => {
  if (!connectionId) {
    throw new Error("connectionId is required for connectorClient");
  }

  return {
    get: (url, config = {}) =>
      apiServices.get(url, {
        ...config,
        headers: {
          ...config.headers,
          "x-connection-id": connectionId,
        },
      }),

    post: (url, data, config = {}) =>
      apiServices.post(url, data, {
        ...config,
        headers: {
          ...config.headers,
          "x-connection-id": connectionId,
        },
      }),

    put: (url, data, config = {}) =>
      apiServices.put(url, data, {
        ...config,
        headers: {
          ...config.headers,
          "x-connection-id": connectionId,
        },
      }),

    delete: (url, config = {}) =>
      apiServices.delete(url, {
        ...config,
        headers: {
          ...config.headers,
          "x-connection-id": connectionId,
        },
      }),
  };
};

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.post(url, { ...config });

  return res.data;
};
